import React from 'react';
import ImageTextBlock from './ImageTextBlock';
import './Contact.css';

const AddressBlock: React.FC = () => (
  <div className="contact-address-block">
    <strong>Address: </strong>
    <a
      className="contact-address-link"
      href="https://www.google.com/maps/place/304+Goodman's+Hill+Rd,+Sudbury,+MA+01776/"
      target="_blank"
      rel="noopener noreferrer"
    > 304 Goodmans Hill Road, Sudbury, MA 01776
    </a>
    <div className="contact-address-gallery">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11789.231021370759!2d-71.412221!3d42.37859!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e38fa6ac910ff1%3A0xd5df0eefd9437501!2s304%20Goodman&#39;s%20Hill%20Rd%2C%20Sudbury%2C%20MA%2001776!5e0!3m2!1sen!2sus!4v1748459138353!5m2!1sen!2sus"
        loading="lazy"
        title="Google Map of 304 Goodmans Hill Road"
        allowFullScreen
      ></iframe>
      <img
        src="/images/workshop_exterior.jpg"
        alt="Exterior image of Colin Skofield's workshop"
      />
    </div>
  </div>
);

const Contact: React.FC = () => (
    <section>
        <h2>Contact</h2>

        {/* Primary Contact Block */}
        <ImageTextBlock
            imageSrc="/images/colin_bench.jpg"
            imageAlt="Collage of instruments for sale"
            text={
                <>
                    Please contact me to inquire about repair and restoration services for your instrument, to schedule an appointment, or to discuss commissions for work.<br />
                    <br />
                    <a href="mailto:colin.skofield.violins@gmail.com" > colin.skofield.violins@gmail.com</a><br /><br />
                    <a href="tel:617-763-1606">(617) 763-1606</a> (text or call)<br /><br />
                    <b>Hours by appointment only.</b>
                </>
            }
        />

    {/* Address Block */}
    <AddressBlock />

        {/* Image of workshop interior */}
        <img src="/images/workshop_interior.jpg" alt="Colin Skofield's workbench" width="100%" />
    </section>
);

export default Contact;